// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal_overlay__Qlv_u","modal":"modal_modal__sJh_h","close":"modal_close__X5B2U"};